var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoContainer"},[_c('video',{ref:"videoPlayer",staticStyle:{"width":"100%"},attrs:{"id":"video","poster":_vm.posterUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }